import React, {  useCallback } from "react";
import { useSelector } from "react-redux";
import {  Form } from "semantic-ui-react";
import { AddBtn } from "../../../commonComponents/AddBtn";
import { FormTitle } from "../../../commonComponents/FormTitle";
import List from "../../../commonComponents/List";
import { CustomLoader } from "../../../commonComponents/formComponents/loader";
import CustomOfficesDetails from "./customOfficesDetails";
import { useCustomOffices } from "../../hooks/useCustomOffices";
import { TranslateContext } from "../TranslateContext";
import { useGetCustomsOfficeDS } from "../../hooks/useGetCustomsOfficeDS";
import { useValidateCustomOfficesCode } from "../../hooks/AGS/useValidateCustomOfficesCode";
import { confirmAlert } from "react-confirm-alert";

const CustomOffices = ({isImportShipment,isDms,updateError}) => {
  const {isLoading,AddItem,deleteItem,updateItem,saveItem}=useCustomOffices({actionType:"HEADER",tableName:"customsOffice",containerKey:"header"})
  const customOfficeList = useGetCustomsOfficeDS()

  const translate = React.useContext(TranslateContext).translate
  const customOfficeTypeList = useSelector((state) => state.DropDownValues[isImportShipment ? "impCustomOfficeTypes" :"expCustomOfficeTypes"]); 
  const {validateCustomOffices}=useValidateCustomOfficesCode()
  const validateOfficeType=useCallback((selectedOffice)=>{
    return customOfficeList.some(c=>c.type==selectedOffice)
  },[customOfficeList])
 
  const onOfficeNameChange=useCallback(({id,value,type})=>{
        saveItem({id,office:value,type})
        updateItem(id,{"office":value?.trim()})
        !isDms && !isImportShipment && updateError(validateCustomOffices({id,office:value?.trim(),type}))
  },[saveItem,updateItem,updateError,validateCustomOffices,isDms,isImportShipment])

  const onOfficeTypeChange=useCallback(({value,id})=>{
    if(validateOfficeType(value)){
      confirmAlert({
        message:`Only 1 of type ${value} is allowed`,
        buttons: [{label: 'OK'}]
      });
    }
    else{
      saveItem({id,type:value,office:" "})
      updateItem(id,{type:value?.trim(),office:""})
     }
  },[saveItem,updateItem,validateOfficeType])

  const renderItem=useCallback((item)=>{
    return <CustomOfficesDetails
     key={item.id}
     item={item}
     deleteData={deleteItem}
     customOfficeTypeList={customOfficeTypeList}
     onOfficeNameChange={onOfficeNameChange}
     onOfficeTypeChange={onOfficeTypeChange}
    />
   },[deleteItem,customOfficeTypeList,onOfficeNameChange,onOfficeTypeChange])
  
  return (
  
    <Form.Group className="float-container">
         <FormTitle title={translate("CUSTOM_OFFICES", {ns:["default", "header"]})}></FormTitle>
        <List 
          dataSource={customOfficeList}
          renderItem={renderItem}
        />
  
      { isLoading && <CustomLoader /> }
      {
        (customOfficeList?.length!=customOfficeTypeList?.length) && 
        <AddBtn id={`custom-office-add`} onClick={AddItem} text={translate("ADD")} />
      }

     
      </Form.Group>
   
  );
}

export default React.memo(CustomOffices)
